import { jsx } from "react/jsx-runtime";
import "react";
const VoteUp = ({ isActive = false })=>{
    if (isActive) return /*#__PURE__*/ jsx("svg", {
        width: "17",
        height: "15",
        viewBox: "0 0 17 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 14.8978H3.04727V5.95911H0V14.8978ZM16.76 6.704C16.76 5.88462 16.0744 5.21422 15.2364 5.21422H10.4369L11.1987 1.78773V1.56427C11.1987 1.26631 11.0464 0.968355 10.894 0.744889L10.056 0L5.028 4.91627C4.72327 5.13973 4.57091 5.51218 4.57091 5.95911V13.408C4.57091 14.2274 5.25655 14.8978 6.09455 14.8978H12.9509C13.5604 14.8978 14.0936 14.5253 14.3222 14.0039L16.6076 8.7152C16.76 8.56622 16.76 8.41724 16.76 8.19378V6.704Z",
            fill: "#4F6F8F"
        })
    });
    return /*#__PURE__*/ jsx("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M3.86 15.34V5.1L8.36 0.34C8.54133 0.153333 8.75591 0.0433333 9.00374 0.01C9.25155 -0.0233333 9.49031 0.0266667 9.72 0.16C9.94667 0.293333 10.1167 0.476667 10.23 0.71C10.3433 0.943333 10.3713 1.18667 10.314 1.44L9.54 5.1H15.52C15.84 5.1 16.12 5.22 16.36 5.46C16.6 5.7 16.72 5.98 16.72 6.3V7.93678C16.72 8.03226 16.73 8.13 16.75 8.23C16.77 8.33 16.76 8.42667 16.72 8.52L14.2 14.32C14.0816 14.6033 13.8843 14.8442 13.6081 15.0425C13.3319 15.2408 13.0425 15.34 12.74 15.34H3.86ZM5.06 5.6V14.14H13L15.52 8.16V6.3H8.06L9.12 1.32L5.06 5.6ZM1.2 15.34C0.87 15.34 0.5875 15.2225 0.3525 14.9875C0.1175 14.7525 0 14.47 0 14.14V6.3C0 5.97 0.1175 5.6875 0.3525 5.4525C0.5875 5.2175 0.87 5.1 1.2 5.1H3.86V6.3H1.2V14.14H3.86V15.34H1.2Z",
            fill: "#4F6F8F"
        })
    });
};
const Assets_VoteUp = VoteUp;
export { Assets_VoteUp as default };
